import React from 'react';
import './footer.css'; // Import the CSS file

// Icons as separate JSX components
const GooglePlayButton = () => (
  <a href="https://play.google.com/store/apps" className="store-button google-play">
    <img className = "footer-img" src="https://assets.republic.com/assets/layouts/play-store-0d44180dd0587978e08f2ac3eb53b810461ff33756799fef2981667aee24dd2a.png" alt="Get it on Google Play" />
  </a>
);

const AppStoreButton = () => (
  <a href="https://apps.apple.com/app" className="store-button app-store">
    <img className = "footer-img" src="https://assets.republic.com/assets/layouts/app-store-9101bc9fe34a6cdc55e4436229c0ba5125905ec10aa243ce3346ab6e36e8d5c6.png" alt="Download on the App Store" />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
  <div className="footer-column">
    {/* <h4 className='footer-h4'>Column 1</h4> */}
    <img 
            src="https://assets.republic.com/assets/logo/full/white/logo-f84869c4f7fd2d0fe2ff22e9a15c82b63809ed42014f19c2a8e3bb455778c6df.svg" 
            alt="Brand Logo" 
            className="navbar-logo" 
          />
    <p>Giving everyone access to early-stage startup investing.</p>
  </div>
  <div className="footer-column">
    <h4 className='footer-h4'>For Investors</h4>
    <hr className="footer-hr" />

    <ul>
      <li><a href="#why-invest">Why invest</a></li>
      <li><a href="#how-it-works">How it works</a></li>
      <li><a href="#faq">FAQ</a></li>
      <li><a href="#risks">Risks</a></li>
      <li><a href="#privacy-policy">Privacy policy</a></li>
      <li><a href="#accessibility">Accessibility</a></li>
      <li><a href="#cookie-preferences">Cookie Preferences</a></li>
      <li><a href="#form-crs">Form CRS</a></li>
    </ul>
  </div>
  <div className="footer-column">
    <h4 className='footer-h4'>For Startups</h4>
    <hr className="footer-hr" />

    <ul>
      <li><a href="#why-raise">Why raise</a></li>
      <li><a href="#learn">Learn</a></li>
      <li><a href="#faq">FAQ</a></li>
      <li><a href="#instruments">Instruments</a></li>
      <li><a href="#crowd-safe">Crowd SAFE</a></li>
      <li><a href="#tokenized-assets">Tokenized assets</a></li>
    </ul>
  </div>
  <div className="footer-column">
    <h4 className='footer-h4'>Company</h4>
    <hr className="footer-hr" />

    <ul>
      <li><a href="#about">About</a></li>
      <li><a href="#journal">Journal</a></li>
      <li><a href="#events">Events</a></li>
      <li><a href="#contact">Contact</a></li>
      <li><a href="#we-re-hiring">We're hiring!</a></li>
    </ul>
  </div>
</div>

    <div className="footer-download-buttons">
      <GooglePlayButton />
      <AppStoreButton />
    </div>
  </footer>
);

export default Footer;
